import React, { Component } from "react";
import PaymentResultPage from "./PaymentResultPage";

export class PaymentSuccess extends Component {
  state = {
    shouldAnimateCard: false,
  };

  componentDidMount() {
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge instanceof HTMLElement) {
      badge.style.display = "none";
    }

    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  render() {
    return (
      <PaymentResultPage
        pageTitle="Ödeme Talimatı"
        pageSubtitle="Talimat işleminiz başarıyla tamamlandı."
        themeClass="t-memberDetail-header--green"
        iconClass="t-icon-check_circle_outline"
        title="Talebiniz Alınmıştır"
        message="Talimatınızı talimatlarım menüsünden takip edebilirsiniz."
        shouldAnimateCard={this.state.shouldAnimateCard}
        primaryAction={{
          to: "/Home/ListPayments",
          label: "Talimatlarıma Git",
        }}
        secondaryAction={{
          to: "/Home/CreatePayment",
          label: "Yeni Talimat",
          icon: "t-icon-add",
        }}
      />
    );
  }
}

export default PaymentSuccess;
